/* Progressive enhancement: Shopify forms remain functional without JavaScript. */
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const select = section.querySelector('[data-variant-select]');
      const source = section.querySelector('[data-variants]');
      if (!select || !source) return;
      let variants;
      try { variants = JSON.parse(source.textContent); } catch { return; }
      const picker = section.querySelector('[data-size-picker]');
      const buttons = picker ? [...picker.querySelectorAll('[data-size]')] : [];
      const sizePosition = buttons.length ? Number(buttons[0].dataset.position) - 1 : -1;
      // Keep the complete variant select if another option has multiple values.
      const simpleSizes = sizePosition >= 0 && variants.every(v => v.options.every((value, i) => i === sizePosition || value === variants[0].options[i]));
      const update = (changeUrl = false) => {
        const variant = variants.find(v => String(v.id) === select.value);
        if (!variant) return;
        const option = select.selectedOptions[0];
        section.querySelector('[data-price]').textContent = option.dataset.price;
        section.querySelector('[data-compare]').textContent = option.dataset.compare || '';
        const add = section.querySelector('[data-add]');
        add.disabled = !variant.available;
        add.innerHTML = variant.available ? 'ADD TO BAG <span>↗</span>' : 'SOLD OUT';
        buttons.forEach(button => {
          const match = variants.find(v => v.options[sizePosition] === button.dataset.size);
          button.disabled = !match || !match.available;
          button.setAttribute('aria-pressed', String(variant.options[sizePosition] === button.dataset.size));
        });
        if (changeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };
      if (simpleSizes) {
        picker.hidden = false;
        section.querySelector('.variant-select').hidden = true;
        buttons.forEach(button => button.addEventListener('click', () => {
          const variant = variants.find(v => v.options[sizePosition] === button.dataset.size && v.available);
          if (!variant) return;
          select.value = String(variant.id);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }));
      }
      select.addEventListener('change', () => update(true));
      update();
    });
    root.querySelectorAll('.mobile-nav').forEach(menu => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => menu.open = false));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
